'use client';

import { Spinner } from '@chakra-ui/react';

export const Loading = (): JSX.Element => {
  return <Spinner color="accent.lightGreen" />;
};
